import {h, Fragment} from "preact"
import { useCurrencyFormatting } from "@nosto/preact"

export default function SelectedFiltersInFacet({ filtersOfFacet, facetName, isRangeFacet, maxValue, removeFilters, layout }) {
    
    const { format } = useCurrencyFormatting();


    return (
            <div class={`filter-group__values-header ns-selected-facet-filters-wrapper ns-selected-facet-filters-${layout} ${layout === "mobile" && filtersOfFacet.length < 1 ? "ns-d-none" : ""}`}>
                <span class="filter-group__values-active-values fs-body-50">
                 {isRangeFacet ? `The highest price is ${format(maxValue)}` : filtersOfFacet.length > 0 ? filtersOfFacet.map((filter, i) => `${filter.value}${i !== filtersOfFacet?.length - 1 ? ", " : ""}`) : layout === "desktop" ? (
                    "0 selected"
                 ) : ""}   
                </span>
                {filtersOfFacet.length > 0 || (isRangeFacet && filtersOfFacet) ? <button type="button" class="btn btn--text-link fs-body-50 filter-group__reset active ns-clear-facet-field-btn" onClick={removeFilters}>
                    Clear
                </button> : null}
            </div>
    )
}